var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasswordToggleIconClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(1344 18)",
    fill: "#f58181",
    opacity: 0.87
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1344 -18)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-20835.033-1595.718l-16-16a.763.763,0,0,1,0-1.062.752.752,0,0,1,1.063,0l2.141,2.141a11.864,11.864,0,0,1,5.082-1.11,11.945,11.945,0,0,1,8.594,3.6,13.2,13.2,0,0,1,2.59,3.6.7.7,0,0,1,.063.3.7.7,0,0,1-.062.3,13.2,13.2,0,0,1-2.59,3.6,12.8,12.8,0,0,1-1.848,1.533l2.031,2.031a.752.752,0,0,1,0,1.063.736.736,0,0,1-.529.22A.752.752,0,0,1-20835.033-1595.718Zm-2.055-4.18a12.394,12.394,0,0,0,4-4.351,12.585,12.585,0,0,0-2.162-2.884,10.335,10.335,0,0,0-7.494-3.119,10.461,10.461,0,0,0-3.949.745l1.488,1.489a4.458,4.458,0,0,1,2.461-.732,4.474,4.474,0,0,1,3.176,1.319,4.535,4.535,0,0,1,1.32,3.182,4.5,4.5,0,0,1-.729,2.458Zm-2.99-2.99a3.011,3.011,0,0,0,.328-1.361,3.035,3.035,0,0,0-.508-1.67,2.958,2.958,0,0,0-1.344-1.1,2.985,2.985,0,0,0-1.146-.225,2.743,2.743,0,0,0-.586.058,3.015,3.015,0,0,0-.777.269Zm-11.264,2.543a13.463,13.463,0,0,1-2.586-3.58c0-.01-.01-.016-.01-.021a.7.7,0,0,1-.062-.3.7.7,0,0,1,.063-.3,13.153,13.153,0,0,1,2.6-3.6c.314-.314.645-.612.984-.89l1.063,1.063c-.324.262-.645.549-.947.848a12.365,12.365,0,0,0-2.162,2.884,12.417,12.417,0,0,0,2.162,2.884,10.321,10.321,0,0,0,7.494,3.114,10.59,10.59,0,0,0,2.811-.372l1.2,1.2a12,12,0,0,1-4.01.675A11.914,11.914,0,0,1-20851.342-1600.345Zm7.715.508a4.463,4.463,0,0,1-2.3-1.23,4.5,4.5,0,0,1-1.236-2.308,4.563,4.563,0,0,1,.152-2.324l1.271,1.272a2.934,2.934,0,0,0,.221,1.324,3.009,3.009,0,0,0,1.1,1.345,2.971,2.971,0,0,0,1.67.508c.057,0,.115,0,.178-.005l1.266,1.267a4.557,4.557,0,0,1-1.443.235A4.455,4.455,0,0,1-20843.627-1599.837Z",
    transform: "translate(22199 1634)",
    fill: "rgba(0,0,0,0.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordToggleIconClosed);
export default __webpack_public_path__ + "static/media/password-toggle-icon-closed.29bacad2df51fe2df1a8003b9a303769.svg";
export { ForwardRef as ReactComponent };